import { render } from "./Web_XML.vue?vue&type=template&id=d7af49d6"
import script from "./Web_XML.vue?vue&type=script&lang=js"
export * from "./Web_XML.vue?vue&type=script&lang=js"

import "./Web_XML.vue?vue&type=style&index=0&id=d7af49d6&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__